// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"28b8db78","453":"5e9b54a8","455":"fd4a4dcd","977":"e39dd069"}[chunkId] + ".chunk.js";
};